import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GLOBAL_ERROR_CODE } from '~graphql-types';
import useDisplayToast from './use-display-toast';

export default function useDisplayResponseErrorToast() {
  const { t } = useTranslation();
  const displayToast = useDisplayToast();

  const displayResponseErrorToast = useCallback(
    (error) => {
      if (!error) return;

      const { networkError, graphQLErrors } = error;
      if (graphQLErrors?.length > 0) {
        // Global error will be handled in apollo client
        if (Object.values(GLOBAL_ERROR_CODE).includes(graphQLErrors[0].code)) {
          return;
        }

        const toast = t(`toast.error.${graphQLErrors[0].message}`);
        const hasErrorCodeBeenTranslated = toast.indexOf('toast.error') === -1;
        displayToast('error', hasErrorCodeBeenTranslated ? toast : graphQLErrors[0].message);
        return;
      }
      if (networkError) {
        displayToast('error', networkError.message);
        return;
      }
      displayToast('error', error.message);
    },
    [displayToast, t]
  );

  return displayResponseErrorToast;
}
